import {onDOMContentLoaded} from "../../../utils";
import clinicsMapRun from "./clinics-map" ;

onDOMContentLoaded(() => {
    clinicsMapRun();
})